import { CUSTOMERS_URL } from '../constants'; // Define the base URL for customers API
import { apiSlice } from './apiSlice';

export const customersApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Fetch all customers with filtering and pagination
    getCustomers: builder.query({
      query: ({ keyword = '', pageNumber = 1 }) => ({
        url: CUSTOMERS_URL,
        params: { keyword, pageNumber }, // Enable filtering and pagination
      }),
      keepUnusedDataFor: 5, // Cache unused data for 5 seconds
      providesTags: ['Customers'], // Tag used for cache invalidation
    }),

    // Fetch a single customer by ID
    getCustomerDetails: builder.query({
      query: (customerId) => ({
        url: `${CUSTOMERS_URL}/${customerId}`,
      }),
      keepUnusedDataFor: 5, // Cache unused data for quick access
    }),

    // Create a new customer
    createCustomer: builder.mutation({
      query: (data) => ({
        url: CUSTOMERS_URL,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Customers'], // Refresh customer list cache
    }),

    // Update an existing customer by ID
    updateCustomer: builder.mutation({
      query: (data) => ({
        url: `${CUSTOMERS_URL}/${data.customerId}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['Customers'], // Refresh customer list after update
    }),

    // Delete a customer by ID
    deleteCustomer: builder.mutation({
      query: (customerId) => ({
        url: `${CUSTOMERS_URL}/${customerId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Customers'], // Refresh customer list cache
    }),

    // Fetch top customers (based on specific criteria such as sales)
    getTopCustomers: builder.query({
      query: () => `${CUSTOMERS_URL}/top`,
      keepUnusedDataFor: 5, // Cache unused data for quick access
    }),
  }),
});

export const {
  useGetCustomersQuery, // Hook to fetch all customers
  useGetCustomerDetailsQuery, // Hook to fetch details of a specific customer
  useCreateCustomerMutation, // Hook to create a customer
  useUpdateCustomerMutation, // Hook to update a customer
  useDeleteCustomerMutation, // Hook to delete a customer
  useGetTopCustomersQuery, // Hook to fetch top customers
} = customersApiSlice;